export default {"src":"/_next/static/media/numa.ff8e6a57.svg","height":30,"width":84,"blurWidth":0,"blurHeight":0};